import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import {  message, Divider } from "antd";
import moment from 'moment'

import EachSyncReport from './EachSyncReport/EachSyncReport';
import { fetchSyncInfoWasabi } from "../../../actions/sync-info-wasabi";
import { refresh_profile } from "../../../actions/auth";
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

import './SyncList.scss';

// This component gets all the information to create reports
class SyncList extends Component{

    constructor(props) {
        super();
        const { user } = props;

        this.state={
            syncInfoList:[],
            sync_frequency:[
                {
                    id : 0,
                    title : "Not Set"
                },
                {
                    id : 1,
                    title : "Every 12 Hours"
                },
                {
                    id : 2,
                    title : "Every Day"
                },
                {
                    id : 3,
                    title : "Every Week"
                },
                {
                    id : 4,
                    title : "Every Month"
                }]
    
         }
    }

    componentDidMount() {
        this.props.fetchSyncInfoWasabi();
        this.props.refresh_profile(true);
    
    }

    componentWillReceiveProps({ syncInfoWasabi, user }) {
        if (syncInfoWasabi.error) {
          message.error(syncInfoWasabi.error);
        } else {
          this.setState({
            syncInfoList: syncInfoWasabi.items,
            user
          });
        }
    }    

    handleDeleteClick  = (syncId) => {
        CloudFlyerAPI
        .user_account
        .deleteSyncWasabi(syncId)
        .then(response => {
            message.success("Sync Information deleted successfully!")
            this.props.fetchSyncInfoWasabi();
        })
        .catch(err => {
            message.error("Something went wrong.")
        })
    }

    handleTriggerClick  = (syncId) => {
        CloudFlyerAPI
        .user_account
        .triggerSyncWasabi(syncId)
        .then(response => {
            message.success("Sync started successfully!")
            this.props.fetchSyncInfoWasabi();
        })
        .catch(err => {
            message.error("Something went wrong.")
        })
    }

    render(){
        const syncTableHeader = <ul>
                                    <li>Id</li>
                                    <li>Source</li>
                                    <li>Destination</li>
                                    <li>Sync Frequency</li>
                                    <li>Sync Date/Time</li>
                                    <li>Actions</li>
                                </ul>

        const syncList=this.state.syncInfoList.map((sl,index) =>{
            let syncF = this.state.sync_frequency.find(sf => sf.id === sl.frequency)  ||  {}
            return (
                <EachSyncReport
                    id = {sl.id}
                    source={sl.source_cloud_name + " > " + sl.source_bucket}
                    source={sl.source_bucket}
                    // destination={sl.destination_cloud_name + " > " + sl.destination_bucket}
                    syncFrequency={ syncF.title}
                    date={moment(sl.last_sync_date).format('MMMM Do YYYY, h:mm:ss a')}
                    key={index}
                    handleDeleteClick = {this.handleDeleteClick}
                    handleTriggerClick = {this.handleTriggerClick}
                />
            )
        })

        return(
            <div className="syncWrapper">
                <div className="syncTableHeader">
                    {syncTableHeader}
                </div>
                <Divider className="syncListDivider"/>
                <div className="syncListWrapper">
                    {syncList}
                </div>
            </div>
        )
    }
}


function mapStateToProps({ syncInfoWasabi, auth: { user } = {} }) {
    return { syncInfoWasabi, user };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
        fetchSyncInfoWasabi: bindActionCreators(fetchSyncInfoWasabi, dispatch),
        refresh_profile
    };
  }
  
  export default withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SyncList)
  );
